import { useLocation, useNavigate } from 'react-router-dom'
import { ActionIcon, Flex, Menu, NavLink } from '@mantine/core'
import { IconChevronLeft, IconDotsVertical } from '@tabler/icons-react'

import type { UserInfoHeaderProps } from '@/modules/advisors/users/pages/[id]/components/UserInfoHeader/UserInfoHeader.types'
import { AdvisorUsersRoutePathsEnum } from '@/modules/advisors/users/routes/advisorsUsersRouteConfig.types'

import { Title } from '@/components/Title/Title'

import classes from './UserInfoHeader.module.css'

const NAVIGATION_ITEMS = [
  { label: 'Overview', path: AdvisorUsersRoutePathsEnum.USER },
  { label: 'Accounts', path: AdvisorUsersRoutePathsEnum.ACCOUNTS },
  { label: 'Transactions', path: AdvisorUsersRoutePathsEnum.TRANSACTIONS },
  { label: 'Action Plan', path: AdvisorUsersRoutePathsEnum.ACTION_PLAN },
  { label: 'Questionnaire', path: AdvisorUsersRoutePathsEnum.QUESTIONNAIRE },
]

export function UserInfoHeader({ user, userId }: UserInfoHeaderProps) {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const handleGoBackClick = () => {
    navigate(AdvisorUsersRoutePathsEnum.USERS)
  }

  const resolvedNavItems = NAVIGATION_ITEMS.map(item => {
    const path = item.path.replace(':id', userId)

    return {
      isActive: pathname === path,
      label: item.label,
      path,
    }
  })

  return (
    <>
      <NavLink
        className={classes.navlink}
        fw={400}
        label={
          <Flex gap={4}>
            <IconChevronLeft size={20} />
            Back to list
          </Flex>
        }
        mb={20}
        onClick={handleGoBackClick}
      />

      <Flex className={classes.detailsContainer} mb={24}>
        <Title variant="h1_big">
          {user.firstName} {user.lastName}
        </Title>

        <Flex className={classes.tabsDesktop} gap={8}>
          {resolvedNavItems.map(item => (
            <NavLink
              key={item.path}
              active={item.isActive}
              className={classes.tabLink}
              label={item.label}
              onClick={() => navigate(item.path)}
            />
          ))}
        </Flex>

        <Menu position="bottom-end" radius={8} shadow="md">
          <Menu.Target>
            <ActionIcon
              className={classes.menuButton}
              radius={8}
              size="lg"
              variant="default"
            >
              <IconDotsVertical size={20} />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            {resolvedNavItems.map(item => (
              <Menu.Item
                key={item.path}
                fw={item.isActive ? 700 : 400}
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      </Flex>
    </>
  )
}
